import { render, staticRenderFns } from "./PolicyDocument.vue?vue&type=template&id=45b8caf2&scoped=true&"
import script from "./PolicyDocument.vue?vue&type=script&lang=js&"
export * from "./PolicyDocument.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDocument.vue?vue&type=style&index=0&id=45b8caf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8caf2",
  null
  
)

export default component.exports